module.exports = __webpack_public_path__ + "img/logo-myhappily@2x.e9ff4bab.png";